// extracted by mini-css-extract-plugin
export var dataCell = "_s3-2";
export var dataRow = "_s3-0";
export var headerRow = "_s3-1";